import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../GlobalProvider";
import { Tooltip } from "react-tooltip";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

function Sidebar({ selectedItem }) {
  const { globalState, setGlobalState } = useGlobalState();
  const navigate = useNavigate();

  const navItems = [
    {
      title: "Dashboard",
      img: "/icons/sidebarIcons/dashboard.png",
      path: "/",
    },
    {
      title: "Appointment Request",
      img: "/icons/sidebarIcons/commandCenter.png",
      path: "/appointment-request",
    },
    {
      title: "Appointment Create",
      img: "/icons/sidebarIcons/commandCenter.png",
      path: "/create-appointment",
    },
    {
      title: "Appointment Schedule",
      img: "/icons/sidebarIcons/appointment.png",
      path: "/appointment-schedule",
    },
    {
      title: "Visit Confirmation",
      img: "/icons/sidebarIcons/liveChat.png",
      path: "/visit-confirmation",
    },
    {
      title: "Token",
      img: "/icons/sidebarIcons/fundsBag.png",
      path: "/appointment-fixed",
    },
    {
      title: "Appointment Completed",
      img: "/icons/sidebarIcons/fundsBag.png",
      path: "/appointment-completed",
    },
    {
      title: "Notification & Remainder",
      img: "/icons/sidebarIcons/addControl.png",
      path: "/",
    },
    {
      title: "Report & Analytics",
      img: "/icons/sidebarIcons/pricingAndCity.png",
      path: "/",
    },
    {
      title: "User Management",
      img: "/icons/sidebarIcons/user.png",
      path: "/",
    },
  ];
  const superAdminItems = [
    {
      title: "Dashboard",
      img: "/icons/sidebarIcons/dashboard.png",
      path: "/",
    },
    {
      title: "TV Screen",
      img: "/icons/sidebarIcons/dashboard.png",
      path: "/tv-screen",
    },
    {
      title: "User Management",
      img: "/icons/sidebarIcons/user.png",
      path: "/user-management",
    },
    {
      title: "Appointment Request",
      img: "/icons/sidebarIcons/commandCenter.png",
      path: "/appointment-request",
    },
    {
      title: "Appointment Create",
      img: "/icons/sidebarIcons/commandCenter.png",
      path: "/create-appointment",
    },
    {
      title: "Appointment Schedule",
      img: "/icons/sidebarIcons/appointment.png",
      path: "/appointment-schedule",
    },
    {
      title: "Visit Confirmation",
      img: "/icons/sidebarIcons/liveChat.png",
      path: "/visit-confirmation",
    },
    {
      title: "Token",
      img: "/icons/sidebarIcons/fundsBag.png",
      path: "/appointment-fixed",
    },
    {
      title: "Appointment Completed",
      img: "/icons/sidebarIcons/fundsBag.png",
      path: "/appointment-completed",
    },
    {
      title: "Notification & Remainder",
      img: "/icons/sidebarIcons/addControl.png",
      path: "/",
    },
    {
      title: "Report & Analytics",
      img: "/icons/sidebarIcons/pricingAndCity.png",
      path: "/",
    },
    
  ]
  return (
    <div className={" sidebarMain"}>
      <div className={" d-flex    w-100 align-items-center" + " justify-content-center"}>
        <img src="/images/brandLogo.png" className="brandLogo img-fluid" />
      </div>

      <div className="navItemsContainer">
        {globalState?.user?.role =="admin" && navItems?.map((v, i) => {
          return (
            <div
              onClick={() => navigate(v?.path)}
              className="d-flex align-items-center sideNavItem"
              style={{ background: selectedItem == v?.title ? "#F0B6BA" : " #d7f278" }}
            >
              <p className="mb-0" style={{ color: "#151515" }}>
                {v?.title}
              </p>
            </div>
          );
        })}
        {globalState?.user?.role =="superAdmin" && superAdminItems?.map((v, i) => {
          return (
            <div
              onClick={() => navigate(v?.path)}
              className="d-flex align-items-center sideNavItem"
              style={{ background: selectedItem == v?.title ? "#F0B6BA" : " #d7f278" }}
            >
              <p className="mb-0" style={{ color: "#151515" }}>
                {v?.title}
              </p>
            </div>
          );
        })}
      </div>
      <Tooltip id="my-tooltip" className="custom-tooltip" />
    </div>
  );
  return (
    <div className={globalState?.isFillSidebarWidth100 ? " sidebarMain" : " miniSideBar"}>
      <div
        className={
          " d-flex    w-100 align-items-center" +
          (globalState?.isFillSidebarWidth100 ? " justify-content-between" : " justify-content-center")
        }
      >
        <div className="d-flex justify-content-center">
          <img src="/images/brandLogo.png" className="brandLogo img-fluid" />
        </div>
        <i
          className="fa fa-bars text-light"
          style={{ fontSize: "22px" }}
          onClick={() =>
            setGlobalState({
              ...globalState,
              isFillSidebarWidth100: !globalState.isFillSidebarWidth100,
            })
          }
        ></i>
      </div>
      {/* <div className="d-flex justify-content-center align-items-center  logoGroup">
        <div>
          <img
            src="/icons/sidebarIcons/brandLogo.png"
            className="mx-2"
            style={{
              height: globalState?.isFillSidebarWidth100 ? " 100px" : " 60px",
              marginBottom: globalState?.isFillSidebarWidth100 ? " 0px" : " -35px",
            }}
          />
        </div>

        {globalState?.isFillSidebarWidth100 && <img src="/icons/sidebarIcons/mie_ride.png" className="mx-2" />}
      </div> */}
      <div className="navItemsContainer">
        {navItems?.map((v, i) => {
          return (
            <div
              onClick={() => navigate(v?.path)}
              className="d-flex align-items-center sideNavItem"
              style={{ background: selectedItem == v?.title ? " #d7f278" : "#353434" }}
            >
              {globalState?.isFillSidebarWidth100 ? (
                // <img src={v?.img} />
                <></>
              ) : (
                // <img src={v?.img} data-tooltip-id="my-tooltip" data-tooltip-content={v?.title.length >11 ? v?.title?.substring(0, 8) + "..." :v?.title} />
                <Tippy
                  style={{ background: "red" }}
                  content={
                    <span style={{ color: "#139F01", fontFamily: "poppins", borderRadius: "6px", padding: "2px 4px" }}>
                      {v?.title}
                    </span>
                  }
                  placement="top"
                  theme="custom-tooltip"
                >
                  <img src={v?.img} alt="Icon" />
                </Tippy>
              )}

              {globalState?.isFillSidebarWidth100 && (
                <p className="mb-0" style={{ color: selectedItem == v?.title ? "#151515" : "#fff" }}>
                  {v?.title}
                </p>
              )}
            </div>
          );
        })}
      </div>
      <Tooltip id="my-tooltip" className="custom-tooltip" />
    </div>
  );
}

export default Sidebar;
